import { CarOwner, DamageCountRecentYears } from "./interfaces";

import { Option as IOption } from "@storeblocks/radio";
import { Option } from "@storeblocks/select";
import { Context } from "Components/TextContext/TextContext";

export const getCarOwnerOptions = (getText: Context["getText"]): IOption[] => [
  {
    id: CarOwner.UNSELECTED,
    label: "",
    value: "",
  },
  {
    id: CarOwner.MYSELF,
    label: getText("carform.optionlabel.carowner-myself"),
    value: CarOwner.MYSELF,
  },
  {
    id: CarOwner.PARTNER,
    label: getText("carform.optionlabel.carowner-partner"),
    value: CarOwner.PARTNER,
  },
  {
    id: CarOwner.GUARDIAN,
    label: getText("carform.optionlabel.carowner-guardian"),
    value: CarOwner.GUARDIAN,
  },
  {
    id: CarOwner.LEASING,
    label: getText("carform.optionlabel.carowner-leasing"),
    value: CarOwner.LEASING,
  },
  {
    id: CarOwner.OTHER,
    label: getText("carform.optionlabel.carowner-other"),
    value: CarOwner.OTHER,
  },
];

export const getBonusOptions = (
  options: any,
  lang: string,
  filter: Array<string> = [],
): Option[] => {
  const bonusData = options.bonusData.map(
    (bonus: { displayName: string; value: string }): Option => ({
      label: bonus.displayName,
      value: bonus.value,
    }),
  );

  const placeholder = {
    label: options.default[lang],
    value: "",
  };

  const bonusDataWithPlaceholder: Array<{ label: string; value: string }> = [
    placeholder,
    ...bonusData,
  ];

  if (filter.length === 0) {
    return bonusDataWithPlaceholder;
  }

  return bonusDataWithPlaceholder.filter((option) =>
    [...filter, placeholder.value].includes(option.value),
  );
};

export const getDamageCountRecentYearsOptions = (
  options: any,
  lang: string,
): IOption[] => [
  {
    label: options.none[lang],
    value: DamageCountRecentYears.NONE,
    id: "DamageCountRecentYears-none",
  },
  {
    label: options.one[lang],
    value: DamageCountRecentYears.ONE,
    id: "DamageCountRecentYears-one",
  },
  {
    label: options.twoOrMore[lang],
    value: DamageCountRecentYears.TWO_OR_MORE,
    id: "DamageCountRecentYears-two",
  },
];
